import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
const EConomicSettingsDisplay = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(SettingsContainer, null,
        React.createElement(SettingRow, null,
            React.createElement(SettingLabel, null, lang.integrations.importAllText),
            React.createElement(SettingValue, null, props.options.importAllInvoices ? lang.misc.yes : lang.misc.no)),
        React.createElement(SettingRow, null,
            React.createElement(SettingLabel, null, lang.integrations.cutoffDateText),
            React.createElement(SettingValue, null, props.options.afterDate
                ? moment(props.options.afterDate).format('L')
                : '-')),
        React.createElement(SettingRow, null,
            React.createElement(SettingLabel, null, props.options.importAllInvoices
                ? lang.integrations.invoiceDate
                : lang.integrations.dueDate),
            React.createElement(SettingValue, null,
                props.options.importAfterDays,
                " ",
                lang.misc.days)),
        React.createElement(SettingRow, null,
            React.createElement(SettingLabel, null, lang.integrations.updateCustomers),
            React.createElement(SettingValue, null, props.options.updateCustomers ? lang.misc.yes : lang.misc.no))));
};
const SettingsContainer = styled.div `
  border: 1px solid lightgray;
  border-radius: 3px;
`;
const SettingRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75em 1em;
  border-bottom: 1px solid lightgray;
  gap: 0.5em;

  &:last-child {
    border-bottom: none;
  }
`;
const SettingLabel = styled.div `
  font-size: 0.9em;
`;
const SettingValue = styled.div `
  white-space: nowrap;
`;
export default EConomicSettingsDisplay;
//# sourceMappingURL=EConomicSettingsDisplay.js.map